import { UrlConstants } from "../url.constants";
export class ApiTownPlanningConstants {
    static URL = UrlConstants.API_V2 + "TownPlanning";
    static FUNCTION_SET_ZONES = "SetTownPlanningZones";
    static FUNCTION_SET_APPLICATION_TYPES = "SetTownPlanningApplicationTypes";
    static FUNCTION_GET_APPLICATION_TYPE_LIMIT = "GetTpApplicationTypeLimit";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetTownPlanningApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetTownPlanningProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateTownPlanningInvoiceReport";
    static FUNCTION_GET_MY_AFLA_PORTAL_TOWN_PLANNING_APPLICATIONS = "GetMyAFLAPortalTownPlanningApplications";
    static FUNCTION_GET_ALL_AFLA_PORTAL_TOWN_PLANNING_APPLICATIONS = "GetAllAFLAPortalTownPlanningApplications";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalTownPlanningApplication";
    static FUNCTION_CREATE_RESUBMITTED_APPLICATION = "CreateResubmittedPortalTownPlanningApplication";
    static FUNCTION_VERIFY_RESUBMISSION_REFERENCE_NUMBER = "VerifyResubmissionReferenceNumber";
}
